import * as React from "react";
import moment from 'moment';
import { toastr } from "react-redux-toastr";
import { StatisticsService, StatsTypes } from "src/share/services/statistics";

export interface IAlertInsightsResponse {
  day: string;
  clicks: number;
  impressions: number;
  views: number;
}

export const useAlertInsights = (alertId: string): [IAlertInsightsResponse[] | null] => {
  const [alertInsights, setAlertInsights] = React.useState<IAlertInsightsResponse[] | null>(null);
  const getAlertInsights = async () => {
    try {
      const { insights } = await StatisticsService.getStats(StatsTypes.ALERTINSIGHTS, { alertId });
      if (insights) {
        const alertInsightsResult = insights.map((row) =>
          ({
            ...row,
            day: moment(row.day).format('MMM DD, YYYY')
          }));
        setAlertInsights(alertInsightsResult)
      } else {
        setAlertInsights([]);
      }
    } catch {
      setAlertInsights([]);
      toastr.error("Error", "There were a problem loading the Alert Insights");
    }
  }
  React.useEffect(() => {
    getAlertInsights()
  }, []);
  return [alertInsights];
}